import throttle from 'lodash/throttle';

/**
 * Creates a throttled function which can take a unique ID argument, to ensure the same function
 * can be called twice with different ID argument.
 *
 * All the arguments, including the ID (first) argument will be passed to the throttled function.
 *
 * Example:
 *    const throttle = throttler(() => {}, 500);
 *    throttle('BAR');
 *    throttle('ZAP');
 *    throttle('BAR');
 *    throttle('BAR');
 *
 * `throttle` with 'BAR' will be called once, and `throttle` with 'ZAP' will be called once.
 */
export default function throttler(fn, wait = 0, opts = {}) {
    const throttles = {};

    const createThrottle = () => throttle(fn, wait, opts);

    return (id, ...args) => {
        if (!throttles[id]) {
            throttles[id] = createThrottle();
        }
        throttles[id].call(null, id, ...args);
    };
}



/** WEBPACK FOOTER **
 ** /src/shared/service/throttler.js
 **/